export interface Category {
  name: string;
  url: string;
  icon: string;
  seq: string;
  imageUrl: string;
}

export const categories: Category[] = [
  {
    name: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    icon: 'ri-footprint-line',
    seq: 'cat-01',
    imageUrl: 'https://readdy.ai/api/search-image?query=Fashionable%20casual%20sneakers%20and%20leather%20shoes%20arranged%20artistically%20on%20clean%20white%20surface%2C%20warm%20natural%20lighting%2C%20soft%20shadows%2C%20editorial%20product%20photography%2C%20cream%20and%20beige%20tones%2C%20minimalist%20aesthetic&width=400&height=300&seq=cat-01&orientation=landscape',
  },
  {
    name: 'Hoodies / Sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    icon: 'ri-t-shirt-line',
    seq: 'cat-02',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cozy%20knitted%20hoodie%20and%20warm%20sweater%20folded%20neatly%20on%20wooden%20shelf%2C%20soft%20textured%20fabric%2C%20warm%20natural%20lighting%2C%20cream%20and%20earth%20tones%2C%20minimalist%20editorial%20photography&width=400&height=300&seq=cat-02&orientation=landscape',
  },
  {
    name: 'T-Shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    icon: 'ri-shirt-line',
    seq: 'cat-03',
    imageUrl: 'https://readdy.ai/api/search-image?query=Premium%20cotton%20t-shirts%20stacked%20in%20neat%20pile%20on%20white%20marble%20surface%2C%20clean%20minimal%20composition%2C%20warm%20natural%20light%2C%20soft%20shadows%2C%20editorial%20fashion%20photography%2C%20cream%20and%20neutral%20palette&width=400&height=300&seq=cat-03&orientation=landscape',
  },
  {
    name: 'Jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    icon: 'ri-vip-crown-line',
    seq: 'cat-04',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stylish%20modern%20jacket%20hanging%20on%20minimalist%20wooden%20hanger%2C%20clean%20studio%20background%2C%20warm%20natural%20lighting%2C%20high-end%20fashion%20photography%2C%20cream%20and%20beige%20color%20palette%2C%20soft%20textured%20details&width=400&height=300&seq=cat-04&orientation=landscape',
  },
  {
    name: 'Pants / Shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    icon: 'ri-pantone-line',
    seq: 'cat-05',
    imageUrl: 'https://readdy.ai/api/search-image?query=Fashionable%20denim%20pants%20and%20casual%20shorts%20neatly%20folded%20on%20light%20fabric%20surface%2C%20clean%20minimal%20composition%2C%20warm%20natural%20lighting%2C%20editorial%20product%20photography%2C%20cream%20and%20beige%20tones&width=400&height=300&seq=cat-05&orientation=landscape',
  },
  {
    name: 'Headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    icon: 'ri-cake-line',
    seq: 'cat-06',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stylish%20caps%20and%20beanies%20arranged%20in%20flat%20lay%20on%20warm%20textile%20background%2C%20clean%20minimal%20composition%2C%20soft%20natural%20lighting%2C%20editorial%20fashion%20photography%2C%20cream%20and%20neutral%20palette&width=400&height=300&seq=cat-06&orientation=landscape',
  },
  {
    name: 'Sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    icon: 'ri-stack-line',
    seq: 'cat-07',
    imageUrl: 'https://readdy.ai/api/search-image?query=Matching%20fashion%20clothing%20set%20displayed%20artistically%20on%20wooden%20hanger%20and%20flat%20surface%2C%20coordinated%20colors%2C%20clean%20minimal%20background%2C%20warm%20natural%20lighting%2C%20editorial%20product%20photography%2C%20cream%20tones&width=400&height=300&seq=cat-07&orientation=landscape',
  },
  {
    name: 'Underwear',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    icon: 'ri-checkbox-blank-line',
    seq: 'cat-08',
    imageUrl: 'https://readdy.ai/api/search-image?query=Premium%20folded%20undergarments%20neatly%20stacked%20on%20clean%20white%20fabric%20surface%2C%20soft%20textured%20cotton%2C%20warm%20natural%20lighting%2C%20minimalist%20editorial%20photography%2C%20cream%20and%20warm%20neutral%20palette&width=400&height=300&seq=cat-08&orientation=landscape',
  },
  {
    name: 'Jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    icon: 'ri-vip-crown-line',
    seq: 'cat-09',
    imageUrl: 'https://readdy.ai/api/search-image?query=Athletic%20sports%20jersey%20displayed%20on%20clean%20minimal%20mannequin%20hanger%2C%20bold%20design%20details%2C%20warm%20studio%20lighting%2C%20editorial%20sports%20fashion%20photography%2C%20cream%20and%20neutral%20background%2C%20professional%20composition&width=400&height=300&seq=cat-09&orientation=landscape',
  },
  {
    name: 'Accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    icon: 'ri-gift-line',
    seq: 'cat-10',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20fashion%20accessories%20flat%20lay%20including%20sunglasses%20watch%20wallet%20and%20jewelry%20on%20clean%20marble%20surface%2C%20warm%20natural%20lighting%2C%20editorial%20luxury%20product%20photography%2C%20cream%20and%20gold%20tones%2C%20minimalist%20aesthetic&width=400&height=300&seq=cat-10&orientation=landscape',
  },
  {
    name: 'Bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    icon: 'ri-handbag-line',
    seq: 'cat-11',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stylish%20leather%20handbag%20and%20backpack%20displayed%20on%20clean%20minimal%20pedestal%2C%20warm%20natural%20lighting%2C%20soft%20shadows%2C%20editorial%20fashion%20product%20photography%2C%20cream%20and%20beige%20palette%2C%20luxury%20aesthetic&width=400&height=300&seq=cat-11&orientation=landscape',
  },
  {
    name: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    icon: 'ri-link-m',
    seq: 'cat-12',
    imageUrl: 'https://readdy.ai/api/search-image?query=Premium%20leather%20belts%20rolled%20and%20displayed%20on%20warm%20wooden%20surface%2C%20metal%20buckle%20detail%2C%20clean%20minimal%20composition%2C%20soft%20natural%20lighting%2C%20editorial%20product%20photography%2C%20cream%20and%20brown%20tones&width=400&height=300&seq=cat-12&orientation=landscape',
  },
  {
    name: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    icon: 'ri-drop-line',
    seq: 'cat-13',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20perfume%20bottles%20arranged%20on%20clean%20marble%20surface%20with%20soft%20light%20reflections%2C%20luxury%20fragrance%20product%20photography%2C%20warm%20natural%20lighting%2C%20cream%20and%20gold%20palette%2C%20minimalist%20aesthetic%2C%20soft%20shadows&width=400&height=300&seq=cat-13&orientation=landscape',
  },
  {
    name: 'Other Stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    icon: 'ri-more-line',
    seq: 'cat-14',
    imageUrl: 'https://readdy.ai/api/search-image?query=Curated%20collection%20of%20miscellaneous%20fashion%20items%20arranged%20artistically%20in%20flat%20lay%20on%20clean%20surface%2C%20warm%20natural%20lighting%2C%20editorial%20product%20photography%2C%20cream%20and%20neutral%20palette%2C%20minimalist%20aesthetic&width=400&height=300&seq=cat-14&orientation=landscape',
  },
];

export const solutions = [
  {
    title: 'Financial Spreadsheet',
    description: 'Track expenses, manage budgets, and forecast revenue with powerful financial templates designed for clarity and precision.',
    icon: 'ri-line-chart-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Financial%20data%20charts%20and%20budget%20spreadsheets%20on%20laptop%20screen%2C%20clean%20modern%20office%20desk%2C%20warm%20natural%20lighting%2C%20minimalist%20workspace%2C%20cream%20and%20beige%20tones%2C%20editorial%20productivity%20photography&width=600&height=400&seq=sol-01&orientation=landscape',
  },
  {
    title: 'Budget Spreadsheet',
    description: 'Create detailed budgets for personal finance or business planning with flexible, easy-to-use spreadsheet structures.',
    icon: 'ri-wallet-3-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Budget%20planning%20notebook%20with%20pen%20and%20calculator%20on%20clean%20desk%2C%20warm%20natural%20lighting%2C%20minimalist%20aesthetic%2C%20cream%20and%20beige%20palette%2C%20editorial%20productivity%20photography&width=600&height=400&seq=sol-02&orientation=landscape',
  },
  {
    title: 'Inventory Spreadsheet',
    description: 'Monitor stock levels, track product movements, and optimize your inventory management with structured tracking systems.',
    icon: 'ri-archive-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Organized%20warehouse%20inventory%20shelves%20with%20product%20boxes%20and%20labels%2C%20clean%20modern%20logistics%20space%2C%20warm%20natural%20lighting%2C%20minimalist%20industrial%20aesthetic%2C%20cream%20and%20beige%20tones%2C%20editorial%20photography&width=600&height=400&seq=sol-03&orientation=landscape',
  },
  {
    title: 'Sales Tracking Spreadsheet',
    description: 'Follow your sales pipeline, monitor performance metrics, and identify growth opportunities with comprehensive sales tools.',
    icon: 'ri-bar-chart-grouped-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Sales%20performance%20dashboard%20with%20colorful%20bar%20charts%20on%20modern%20laptop%20screen%2C%20clean%20office%20desk%2C%20warm%20natural%20lighting%2C%20minimalist%20aesthetic%2C%20cream%20and%20beige%20tones%2C%20editorial%20photography&width=600&height=400&seq=sol-04&orientation=landscape',
  },
  {
    title: 'Project Management Spreadsheet',
    description: 'Coordinate tasks, manage timelines, and collaborate efficiently with purpose-built project tracking solutions.',
    icon: 'ri-task-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Project%20timeline%20and%20task%20management%20board%20on%20laptop%2C%20sticky%20notes%20on%20desk%2C%20warm%20collaborative%20office%20atmosphere%2C%20cream%20and%20beige%20palette%2C%20minimalist%20editorial%20photography&width=600&height=400&seq=sol-05&orientation=landscape',
  },
  {
    title: 'Business Analytics Spreadsheet',
    description: 'Transform raw data into actionable insights with analytics templates that help you make smarter business decisions.',
    icon: 'ri-pie-chart-2-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Business%20analytics%20dashboard%20with%20pie%20charts%20and%20data%20visualization%20on%20monitor%2C%20modern%20office%20workspace%2C%20warm%20natural%20lighting%2C%20minimalist%20aesthetic%2C%20cream%20and%20neutral%20tones%2C%20editorial%20photography&width=600&height=400&seq=sol-06&orientation=landscape',
  },
];